import { z } from "zod";

export const jobRoleSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, "Name is required"),
  searchName: z.string().optional(), // Lowercase for autocomplete
  examIds: z.array(z.string()).default([]), // List of associated exam IDs
});

export type JobRole = z.infer<typeof jobRoleSchema>;

export const createJobRoleSchema = jobRoleSchema.omit({
  id: true,
  searchName: true,
});

export type CreateJobRole = z.infer<typeof createJobRoleSchema>;

export const updateJobRoleSchema = jobRoleSchema.partial();

export type UpdateJobRole = z.infer<typeof updateJobRoleSchema>;

export const createJobRoleSearchName = (name: string) => {
  return name.toLowerCase().trim();
};
